import { Card, ReadOnlySection } from '@cxc/react-fpds-components';
import styles from './EligibilityPanel.module.scss';
import TabSectionProps from '../../../types/props/TabSectionProps';
import {
    CardType,
    ReadOnlySectionItemType,
    ReadOnlySectionType,
} from '../../../types/TabSectionTypes';

export const EligibilityPanel = ({ incentive }: TabSectionProps) => {
    const projectTypeCardElements: ReadOnlySectionType[] = [
        {
            title: 'PROJECT TYPE',
            columnOptions: { xl: 6, l: 6, m: 12, s: 12 },
            items: [
                { title: 'Project Type', content: incentive.eligibleProjectTypes },
                { title: 'Project Description', content: incentive.eligibleProjectTypeDescription },
            ],
        },
    ];

    const elegibleVehicleCardElements: ReadOnlySectionType[] = [
        {
            title: 'ELIGIBLE VEHICLES',
            columnOptions: { xl: 4, l: 4, m: 12, s: 12 },
            items: [
                { title: 'Vehicle Type', content: incentive.eligibleVehicleType },
                { title: 'Vehicle Duties', content: incentive.eligibleVehicleDuties },
                { title: 'Vehicle Fuel Types', content: incentive.eligibleFuelTypes },
            ],
        },
        {
            title: '',
            columnOptions: { xl: 4, l: 4, m: 12, s: 12 },
            items: [
                { title: 'Vehicle Description', content: incentive.eligibleVehicleTypeDescription },
                {
                    title: 'Vehicle Weight Classes',
                    content: incentive.eligibleVehicleWeightClasses,
                },
                { title: 'Vehicle Segments', content: incentive.eligibleOrganizations },
            ],
        },
    ];

    const otherDetailsCardElements: ReadOnlySectionType[] = [
        {
            title: 'OTHER DETAILS',
            columnOptions: { xl: 6, l: 6, m: 12, s: 12 },
            items: [
                { title: 'Charging Technology', content: incentive.eligibleChargingTechnology },
                { title: 'Eligibility Assumptions', content: incentive.eligibilityAssumptions },
            ],
        },
    ];

    const cards: CardType[] = [
        { title: '', content: projectTypeCardElements },
        { title: '', content: elegibleVehicleCardElements },
        { title: '', content: otherDetailsCardElements },
    ];

    return (
        <div
            style={{
                height: 'calc(100vh - [footer-height]px)',
                overflowY: 'auto',
            }}
        >
            {cards.map((card: CardType) => (
                <Card className={styles.eligibilityCard} key={card.title}>
                    {card.content.map((element: ReadOnlySectionType) => (
                        <ReadOnlySection
                            key={element.title}
                            header={{
                                title: element.title,
                            }}
                            columnOptions={element.columnOptions}
                            className="read-only-section"
                            variant="SuperCondensed"
                        >
                            {element.items.map((item: ReadOnlySectionItemType) => (
                                <ReadOnlySection.Item
                                    key={item.title}
                                    label={item.title}
                                    // @ts-expect-error - Need to pass in Link Element therefore JSX is mandatory here
                                    value={item.content}
                                />
                            ))}
                        </ReadOnlySection>
                    ))}
                </Card>
            ))}
        </div>
    );
};
